import React from 'react'
import moment from 'moment'
import { Formik, Form } from 'formik'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import * as Yup from 'yup'

import { PRIORITY_TERM } from '../../constants'
import Button from '../buttons/buttons.component'
import { AsyncSelectInput, DatepickerInput } from '../form-components'
import { TicketSaleService } from './../../services'
import { toastActions, busSeatSelectionActions } from '../../actions'
import {
	iFrameHelper,
	markUpgradableTicket,
	isMobile,
	sortTerminalsByPriority,
	dateHelper,
} from './../../helpers'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { Creators as ProgressBarCreators } from '../../ducks/progress-bar/progress-bar'
import { Creators as TicketSaleCreators } from '../../ducks/ticket-sale/ticket-sale'
import { conexaoActions } from '../../ducks/conexao/conexaoReducer'

import {
	StyledIconFontAwesome,
	SearchContainer,
	InputSearchCity,
	InputSearchDate,
	BtnSearchTrip,
} from './search-form.styles'

import { routes } from '../../constants/routes.constants'

const ALLOWED_RANGE_IN_MONTHS = 24

class SearchFormComponent extends React.Component {
	constructor(props) {
		super(props)

		this.dateGoingRef = React.createRef()
		this.dateReturnRef = React.createRef()
		this.getPlaces = this.getPlaces.bind(this)
		this.setSearchFormField = this.setSearchFormField.bind(this)
		this.preparePurchaseFlow = this.preparePurchaseFlow.bind(this)
		this.getOriginList = this.getOriginList.bind(this)
		this.getDestinationList = this.getDestinationList.bind(this)
		this.alterOriginField = this.alterOriginField.bind(this)
		this.alterDestinationField = this.alterDestinationField.bind(this)
		this.renderFormik = renderFormik.bind(this)
		this.findOrigins = this.findOrigins.bind(this)
		this.findDestinations = this.findDestinations.bind(this)
		this.updateDestinations = updateDestinations.bind(this)
		this.setDestination = this.setDestination.bind(this)
		this.validateLocalities = this.validateLocalities.bind(this)
		this.searchTrips = this.searchTrips.bind(this)
		this.reverseTrip = this.reverseTrip.bind(this)
		this.isRootUrl = this.isRootUrl.bind(this)
		this.isPurchaseUrl = this.isPurchaseUrl.bind(this)
		this.redirectToTicketpurchase = this.redirectToTicketpurchase.bind(this)
		this.getRoutes = this.getRoutes.bind(this)
		this.prepareRoutesToRebooking = this.prepareRoutesToRebooking.bind(this)
		this.setCities = this.setCities.bind(this)
	}

	async componentDidMount() {
		this.props.setTripData({
			tripsGoing: [],
			tripsReturn: [],
		})

		const originList = this.props.originList

		let newOriginList

		if (originList.length) {
			newOriginList = originList
		} else {
			newOriginList = await this.getOriginList()
		}

		this.props.setOriginList(
			sortTerminalsByPriority(newOriginList, PRIORITY_TERM)
		)

		const tripParams = iFrameHelper.getTripParams()

		const { isRebooking, rebookingDestinationId, rebookingOriginId } =
			this.props.rebookingData

		if (isRebooking) {
			this.prepareRoutesToRebooking(
				rebookingOriginId,
				rebookingDestinationId
			)
		}

		if (tripParams.isValidParameters) {
			this.searchTrips({
				...tripParams,
				origin: JSON.stringify({
					id: tripParams.originId,
				}),
				destination: JSON.stringify({
					id: tripParams.destinationId,
				}),
			})
		} else {
			const {
				origin,
				destination,
				tripDateGoingSearch,
				tripDateReturnSearch,
				destinationList,
				rebookingData,
			} = this.props

			let defaultDateGoingSearch = dateHelper.getTomorrowDate()

			if (tripDateGoingSearch) {
				defaultDateGoingSearch = tripDateGoingSearch
			}

			this.props.setTripDateGoingSearch(defaultDateGoingSearch)

			if (this.dateGoingRef.current) {
				this.dateGoingRef.current.changeValue(
					moment(defaultDateGoingSearch)
				)
			}

			if (!origin || !destination || !destinationList) {
				return
			}

			const tripDateReturnValues =
				!isNaN(Date.parse(tripDateReturnSearch)) &&
				!rebookingData.isRebooking
					? tripDateReturnSearch
					: null

			this.props.setStepOrderCurrent(1)
			this.props.setDestinationList(destinationList)
			this.props.setTripDateReturnSearch(tripDateReturnValues)

			this.setSearchFormField({
				originId: JSON.parse(origin.value).id,
				destinationId: JSON.parse(destination.value).id,
				tripDateGoingSearch: defaultDateGoingSearch,
				tripDateReturnSearch: tripDateReturnValues,
			})
		}
	}

	async getOriginList() {
		const { user, muvibus } = this.props
		const { showLoading, hideLoading } = this.props

		showLoading()

		const { data: origins } = await TicketSaleService.getOrigins({
			muvibusState: !!muvibus,
			isPublicBody: user ? user.hasPublicBody : null,
			userId: user ? user.id : null,
		})

		hideLoading()

		if (!origins || !origins.length) return

		const originListReadyToShow = origins.map((origin) => {
			return {
				value: JSON.stringify({
					id: origin.id,
					ibgeCode: origin.ibgeCode,
				}),
				id: origin.id,
				label: `${origin.city} (${origin.state})`,
				city: origin.city,
				hasChildren: origin.hasChildren,
				state: origin.state,
			}
		})

		return originListReadyToShow
	}

	async getDestinationList(origin) {
		const { user, muvibus } = this.props

		let destinationsFoundReadyToShow = []

		try {
			const { data } = await TicketSaleService.getDestinations({
				id: JSON.parse(origin.value).id,
				isMuvibus: muvibus,
				isPublicBody: user ? user.hasPublicBody : null,
				userId: user ? user.id : null,
				hasChildren: origin.hasChildren,
			})

			destinationsFoundReadyToShow = data.map((destination) => ({
				value: JSON.stringify({
					id: destination.id || destination.city,
				}),
				id: destination.id,
				label: `${destination.city} (${destination.state})`,
				city: destination.city,
				state: destination.state,
			}))

			return sortTerminalsByPriority(
				destinationsFoundReadyToShow,
				PRIORITY_TERM
			)
		} catch (error) {
			this.props.toastWarning({
				message: 'Ocorreu um erro ao buscar lista de destinos.',
			})

			return
		}
	}

	findDestinations(inputValue, callback) {
		if (
			!inputValue ||
			inputValue.toUpperCase() === this.props.searchDestinationTerm
		) {
			callback(this.props.destinationList)
			return
		}

		inputValue = inputValue.toUpperCase()

		const destinationListFiltered = this.props.destinationList.filter(
			(item) => item.label.includes(inputValue)
		)

		if (destinationListFiltered.length) {
			this.props.setSearchDestinationTerm(inputValue)

			callback(destinationListFiltered)
		}
	}

	findOrigins(inputValue, callback) {
		if (
			!inputValue ||
			inputValue.toUpperCase() === this.props.searchOriginTerm
		) {
			callback(this.props.originList)
			return
		}

		this.props.setDestination(null)
		this.props.setDestinationList([])

		this.alterDestinationField(
			JSON.stringify({
				id: '',
			})
		)

		inputValue = inputValue.toUpperCase()

		let originListFiltered = this.props.originList.filter((item) =>
			item.label.includes(inputValue)
		)

		if (originListFiltered.length) {
			this.props.setSearchOriginTerm(inputValue)

			callback(originListFiltered)
		}
	}

	setDestination(destination) {
		if (!destination) return

		const destinationId = JSON.parse(destination).id

		const selectedDestination = this.props.destinationList.find(
			({ value }) => JSON.parse(value).id === destinationId
		)

		if (selectedDestination) {
			this.props.setDestination(selectedDestination)
		}
	}

	validateLocalities() {
		const { origin, destination, tripDateGoingSearch } = this.props

		if (!origin || !destination || !tripDateGoingSearch) {
			this.props.toastWarning({
				message: 'Escolha origem, destino e data de ida',
			})
			return
		}

		if (origin.label === destination.label) {
			this.props.toastWarning({
				message: 'A origem e o destino devem ser distintos',
			})
			return
		}

		this.props.setEtapaPagamento(false)

		this.refs.form.submitForm()
	}

	redirectToTicketpurchase() {
		const {
			origin,
			destination,
			tripDateGoingSearch,
			tripDateReturnSearch,
			history,
		} = this.props

		const tripDateReturnValid = tripDateReturnSearch
			? moment(tripDateReturnSearch).format('YYYY/MM/DD')
			: null

		let url = routes.COMPRA_DE_PASSAGEM

		if (document.location.pathname.includes(routes.PLANALTO_SITE)) {
			url +=
				`?IdOrigem=${origin.id}` +
				`&IdDestino=${destination.id}` +
				`&DestinoCity=${destination.city}` +
				`&OriginCity=${origin.city}` +
				`&Empresa=${destination.busCompany}` +
				`&DataIda=${moment(tripDateGoingSearch).format('YYYY/MM/DD')}` +
				`&DataVolta=${tripDateReturnValid}` +
				`&hasChildren=${origin.hasChildren}`
		}

		history.push(url)
	}

	isRootUrl() {
		return document.location.pathname == '/'
	}

	isPurchaseUrl() {
		return !document.location.pathname.includes(routes.COMPRA_DE_PASSAGEM)
	}

	async searchTrips(values) {
		if (this.isRootUrl() || this.isPurchaseUrl()) {
			this.redirectToTicketpurchase()
			this.props.resetRebookingData()
		}

		const { showLoading, hideLoading, resetProgressBar } = this.props

		resetProgressBar()

		const {
			origin,
			destination,
			destinationCity,
			tripDateGoingSearch,
			tripDateReturnSearch,
		} = values

		const originId = JSON.parse(origin).id
		const destinationId = JSON.parse(destination).id || destinationCity

		if (
			!originId ||
			(!destinationId && !destinationCity) ||
			!this.props.originList.length
		) {
			return
		}

		try {
			let { origin, destination, destinationList } = await this.getPlaces(
				originId,
				destinationId
			)

			showLoading()

			this.props.resetConexaoState()

			const { ticketRoutesGoing, ticketRoutesReturn } =
				await TicketSaleService.searchTrips({
					originId,
					destinationId,
					tripDateGoing: tripDateGoingSearch,
					tripDateReturn: tripDateReturnSearch,
					destinationCity: destinationId,
				})

			hideLoading()

			if (!this.props.origin) {
				this.props.setTripDateReturnSearch(tripDateReturnSearch)
				this.props.setTripDateGoingSearch(tripDateGoingSearch)
				this.props.setDestination(destination)
				this.props.setOrigin(origin)
				this.props.setDestinationList(destinationList)

				this.setSearchFormField({
					originId,
					destinationId,
					tripDateGoingSearch,
					tripDateReturnSearch,
				})
			}

			let tripsGoing = []

			if (ticketRoutesGoing && ticketRoutesGoing.ticketRoutes.length) {
				tripsGoing = this.filterBusByFreeSeats(
					ticketRoutesGoing.ticketRoutes
				)
			}

			if (!tripsGoing.length) {
				this.props.toastWarning({
					message: 'Não foi encontrado trechos disponíveis de ida',
				})
				return
			}

			let tripsReturn = []

			if (ticketRoutesReturn && ticketRoutesReturn.ticketRoutes.length) {
				tripsReturn = this.filterBusByFreeSeats(
					ticketRoutesReturn.ticketRoutes
				)
			}

			this.preparePurchaseFlow({
				originTitle: origin,
				originId,
				destinationTitle: destination,
				destinationId,
				tripsGoing,
				tripsReturn,
				tripDateGoingSearch,
				tripDateReturnSearch,
				originList: this.props.originList,
				destinationList,
			})
		} catch (error) {
			hideLoading()
			this.props.toastWarning({
				message: 'Ocorreu um erro ao tentar buscar as viagens',
			})
		}
	}

	async getPlaces(originId, destinationId) {
		let origin = this.props.originList.find(
			(origin) => JSON.parse(origin.value).id === originId
		)

		const destinationList = await this.getDestinationList(origin)

		const destinationFound = destinationList.find(
			(destination) => JSON.parse(destination.value).id === destinationId
		)

		let destination = {
			...destinationFound,
			value: destinationFound.value,
			label: destinationFound.label,
		}

		return { origin, destination, destinationList }
	}

	setSearchFormField({
		originId,
		destinationId,
		tripDateGoingSearch,
		tripDateReturnSearch,
	}) {
		this.alterOriginField(
			JSON.stringify({
				id: originId,
			})
		)

		this.alterDestinationField(
			JSON.stringify({
				id: destinationId,
			})
		)

		this.dateGoingRef.current.changeValue(moment(tripDateGoingSearch))

		if (tripDateReturnSearch) {
			this.dateReturnRef.current.changeValue(moment(tripDateReturnSearch))
		}
	}

	filterBusByFreeSeats(ticketRoutes) {
		let routesWithFreeSeats = []

		if (ticketRoutes.length) {
			routesWithFreeSeats = ticketRoutes
				.filter((route) => route.freeSeats > 0)
				.map(markUpgradableTicket)
		}

		return routesWithFreeSeats
	}

	preparePurchaseFlow(tripData) {
		const {
			resetTicketSale,
			resetProgressBar,
			resetBusSeatSelection,
			setStepOrderCurrent,
			setTripData,
			updateTripDates,
		} = this.props

		resetTicketSale()
		resetProgressBar()
		resetBusSeatSelection()
		setStepOrderCurrent(1)
		updateTripDates(tripData)
		setTripData(tripData)
	}

	setCities({ destination, origin, destinations }) {
		this.props.setDestination(destination)
		this.props.setOrigin(origin)
		this.props.setDestinationList(destinations)

		this.alterOriginField(
			JSON.stringify({
				id: JSON.parse(origin.value).id,
			})
		)

		this.alterDestinationField(destination.value)
	}

	async reverseTrip() {
		const { origin, destination, showLoading, hideLoading, toastWarning } =
			this.props

		if (this.props.rebookingData.isRebooking) {
			toastWarning({
				message: 'Em remarcação não é possível inverter origem e destino.',
			})
			return
		}

		showLoading()

		if (!origin || !destination) {
			hideLoading()
			toastWarning({
				message: 'Escolha origem e destino para poder inverter',
			})
			return
		}

		const newOrigin = this.props.originList.find(
			(originFound) => originFound.city === this.props.destination.city
		)

		if (!newOrigin) {
			hideLoading()
			toastWarning({
				message: 'Não existem opções de origem com o destino selecionado.',
			})

			return
		}

		let destinationsFound = await this.getDestinationList(newOrigin)

		const newDestination = destinationsFound.find(
			(destinationFound) => destinationFound.city === this.props.origin.city
		)

		if (!newDestination) {
			hideLoading()
			toastWarning({
				message: 'Não existem opções de destino com a origem selecionada.',
			})
			return
		}

		this.setCities({
			destination: newDestination,
			destinations: destinationsFound,
			origin: newOrigin,
		})

		hideLoading()
	}

	getRoutes(cityId, routes) {
		return routes.find((routeFound) => routeFound.id === cityId)
	}

	async prepareRoutesToRebooking(originId, destinationId) {
		const newOrigin = this.getRoutes(originId, this.props.originList)

		let destinationsFound = await this.getDestinationList(newOrigin)

		const newDestination = this.getRoutes(destinationId, destinationsFound)

		this.setCities({
			destination: newDestination,
			destinations: destinationsFound,
			origin: newOrigin,
		})
	}

	alterOriginField(value) {
		this.refs.form.setFieldValue('origin', value)
	}

	alterDestinationField(value) {
		this.refs.form.setFieldValue('destination', value)
	}

	render() {
		const schema = Yup.object().shape({
			tripDateGoingSearch: Yup.date(),
			tripDateReturnSearch: Yup.string().nullable(),
			origin: Yup.string('Informe o origem').required('Informe a origem'),
			destination:
				Yup.string('Informe o destino').required('Informe o destino'),
		})

		return (
			<Formik
				ref="form"
				validationSchema={schema}
				render={this.renderFormik}
				onSubmit={this.searchTrips}
			/>
		)
	}
}

async function updateDestinations(newOriginLocality) {
	const originState = this.props.origin

	if (
		!newOriginLocality ||
		(this.props.destinationList.length &&
			originState &&
			newOriginLocality === originState.value)
	) {
		return
	}

	this.alterDestinationField(
		JSON.stringify({
			id: '',
		})
	)

	let newOriginId = JSON.parse(newOriginLocality).id

	const selectedOrigin = this.props.originList.find(
		({ value }) => JSON.parse(value).id === newOriginId
	)

	if (!selectedOrigin) return

	const destinationListReadyToShow = await this.getDestinationList(
		selectedOrigin
	)

	if (!destinationListReadyToShow || !destinationListReadyToShow.length) return

	if (destinationListReadyToShow) {
		this.props.setOrigin(selectedOrigin)
		this.props.setDestinationList(destinationListReadyToShow)
	}
}

function renderFormik(props) {
	return (
		<Form noValidate>
			<SearchContainer>
				<InputSearchCity>
					<AsyncSelectInput
						{...props}
						id="origin"
						placeholder={'Origem'}
						defaultOptions={this.props.originList}
						loadOptions={this.findOrigins}
						onValueChange={this.updateDestinations}
						disabled={this.props.rebookingData.isRebooking}
					/>
				</InputSearchCity>
				<StyledIconFontAwesome
					name="exchange"
					title="Inverter destino"
					onClick={this.reverseTrip}
					id="ico-reverse"
					isRootUrl={!this.isRootUrl()}
				/>
				<InputSearchCity>
					<AsyncSelectInput
						{...props}
						id="destination"
						placeholder="Destino"
						defaultOptions={this.props.destinationList}
						loadOptions={this.findDestinations}
						onValueChange={this.setDestination}
						disabled={this.props.rebookingData.isRebooking}
					/>
				</InputSearchCity>
				<InputSearchDate>
					<DatepickerInput
						{...props}
						id="tripDateGoingSearch"
						placeholder="Data da ida"
						isOutsideRange={(value) => {
							const { tripDateReturnSearch } =
								this.refs.form.state.values
							return (
								value.isBefore(moment().startOf('day')) ||
								value.isAfter(
									moment()
										.startOf('day')
										.add(ALLOWED_RANGE_IN_MONTHS, 'M')
								) ||
								value.isAfter(
									moment(tripDateReturnSearch, 'YYYY-MM-DD').add(
										1,
										'days'
									)
								)
							)
						}}
						onValueChange={this.props.setTripDateGoingSearch}
						ref={this.dateGoingRef}
					/>
				</InputSearchDate>
				<InputSearchDate>
					<DatepickerInput
						{...props}
						showClearDate
						id="tripDateReturnSearch"
						placeholder="Data da volta (opcional)"
						isOutsideRange={(value) => {
							const { tripDateGoingSearch } = this.refs.form.state.values
							return (
								value.isBefore(moment().startOf('day')) ||
								value.isBefore(
									moment(tripDateGoingSearch, 'YYYY-MM-DD')
								)
							)
						}}
						onValueChange={this.props.setTripDateReturnSearch}
						ref={this.dateReturnRef}
						disabled={this.props.rebookingData.isRebooking}
					/>
				</InputSearchDate>
				<BtnSearchTrip>
					<Button
						primary={this.isRootUrl()}
						secondary={!this.isRootUrl()}
						type="button"
						onClick={this.validateLocalities}
						height={isMobile() ? null : '4.5rem'}>
						Buscar
					</Button>
				</BtnSearchTrip>
			</SearchContainer>
		</Form>
	)
}

const mapStateToProps = (store) => {
	return {
		user: store.user,
		origin: store.ticketSale.origin,
		originList: store.ticketSale.originList,
		searchOriginTerm: store.ticketSale.searchOriginTerm,
		destination: store.ticketSale.destination,
		destinationList: store.ticketSale.destinationList,
		searchDestinationTerm: store.ticketSale.searchDestinationTerm,
		tripDateGoingSearch: store.ticketSale.tripDateGoingSearch,
		tripDateReturnSearch: store.ticketSale.tripDateReturnSearch,
		rebookingData: store.ticketSale.rebookingData,
	}
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			toastWarning: toastActions.warning,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
			resetTicketSale: TicketSaleCreators.reset,
			resetProgressBar: ProgressBarCreators.reset,
			setOriginPortal: TicketSaleCreators.setOriginPortal,
			resetBusSeatSelection: busSeatSelectionActions.reset,
			resetConexaoState: conexaoActions.resetConexaoState,
			setStepOrderCurrent: TicketSaleCreators.setStepOrderCurrent,
			setTripData: TicketSaleCreators.setTripData,
			setOrigin: TicketSaleCreators.setOrigin,
			setOriginList: TicketSaleCreators.setOriginList,
			setSearchOriginTerm: TicketSaleCreators.setSearchOriginTerm,
			setDestination: TicketSaleCreators.setDestination,
			setDestinationList: TicketSaleCreators.setDestinationList,
			setSearchDestinationTerm: TicketSaleCreators.setSearchDestinationTerm,
			setTripDateGoingSearch: TicketSaleCreators.setTripDateGoingSearch,
			setTripDateReturnSearch: TicketSaleCreators.setTripDateReturnSearch,
			updateTripDates: TicketSaleCreators.updateTripDates,
			setEtapaPagamento: TicketSaleCreators.setEtapaPagamento,
			resetRebookingData: TicketSaleCreators.resetRebookingData,
		},
		dispatch
	)

export const SearchForm = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SearchFormComponent)
)

export default SearchForm
